module.exports = __webpack_public_path__ + "static/Punting-dbfa76a66d940126655e9b27e516cb50.jpg";